import { success, loading, handleErrorException } from 'State/actions';

import * as types from './types';

export const getPage = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VIEW_APPLICATION_DISTRIBUTION_FETCHING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `ViewApplicationDistribution/GetViewApplicationDistributionPage`
      );
      const result = response.data.Data;
      dispatch(
        success(types.VIEW_APPLICATION_DISTRIBUTION_FETCH_SUCCESS, result)
      );
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.VIEW_APPLICATION_DISTRIBUTION_FETCH_ERROR,
          {
            Title: 'Error',
            Message: 'Could not retrieve page.',
          }
        )
      );
    } finally {
      dispatch(loading(types.VIEW_APPLICATION_DISTRIBUTION_FETCHING, false));
    }
  };
};

export const getResults = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.VIEW_APPLICATION_DISTRIBUTION_FETCHING_RESULTS, true)
    );
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `ViewApplicationDistribution/GetViewApplicationDistributionRecords`,
        data
      );
      dispatch(
        success(types.VIEW_APPLICATION_DISTRIBUTION_FETCH_RECORDS_SUCCESS, {
          TypeId: data.TypeId,
          ...response.data.Data,
        })
      );
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.VIEW_APPLICATION_DISTRIBUTION_FETCH_ERROR,
          {
            Title: 'Error',
            Message: 'Could not retrieve page.',
          }
        )
      );
    } finally {
      dispatch(
        loading(types.VIEW_APPLICATION_DISTRIBUTION_FETCHING_RESULTS, false)
      );
    }
  };
};

export const clearErrors = () => {
  return {
    type: types.VIEW_APPLICATION_DISTRIBUTION_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/viewapplicationdistribution/state/actions.js